'use client';

// Toegankelijke foutfeedback (roadmap 1B): vervangt browser-alert() en stille
// catches. Fouten worden als Mantine-notification getoond (role="alert",
// screenreader-vriendelijk) met een retry-knop wanneer opnieuw proberen zin
// heeft, en gaan door naar error monitoring.

import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { ApiError, friendlyMessage } from './apiError';
import { reportError } from './telemetry';

export function notifyError(error, { title = 'Something went wrong', onRetry, report = true, id: fixedId } = {}) {
  if (report) reportError(error, { source: 'notify' });
  const retryable = onRetry && (!(error instanceof ApiError) || error.retryable);
  // Een vast id voorkomt stapeling bij herhaalde failures (bijv. zoeken-terwijl-je-typt)
  if (fixedId) notifications.hide(fixedId);
  const id = notifications.show({
    id: fixedId,
    color: 'red',
    title,
    autoClose: retryable ? 10000 : 6000,
    withCloseButton: true,
    message: retryable ? (
      <>
        {friendlyMessage(error)}
        <Button
          variant="light"
          color="red"
          size="compact-xs"
          mt={8}
          display="block"
          onClick={() => {
            notifications.hide(id);
            onRetry();
          }}
        >
          Try again
        </Button>
      </>
    ) : (
      friendlyMessage(error)
    ),
  });
  return id;
}

export function notifySuccess(message, { title } = {}) {
  return notifications.show({ color: 'teal', title, message, autoClose: 4000 });
}
